import { lazy } from 'react';
const RegisterProvider = lazy(() => import('../../pages/RegisterProvider'));
const LoginFormMobilePage = lazy(() => import('../../pages/LoginForm'));
const ForgotPasswordContainer = lazy(() =>
  import('../../pages/ForgotPassword/ForgotPasswordContainer'),
);
const NewPassword = lazy(() => import('../../pages/ForgotPassword/NewPassword'));
const UserManagementPage = lazy(() => import('../../pages/user-management'));
const RegisterUserPage = lazy(() => import('../../pages/register-user'));
const EditUserForm = lazy(() => import('../../components/UserManagement/EditUserForm'));
const TermsAndConditionsPage = lazy(() => import('../../pages/termsAndConditionsPage'));

const userRoutes = [
  {
    title: 'Gestionar Usuarios',
    path: 'gestionusuarios',
    component: UserManagementPage,
    permission: 'gestion-usuarios',
    isPrivate: true,
  },
  {
    title: 'Gestión - Registrar Usuarios',
    path: 'gestionusuarios/registrar-usuario',
    component: RegisterUserPage,
    permission: 'registrar-usuarios',
    isPrivate: true,
  },
  {
    title: 'Gestión - Modificar Usuario',
    path: 'gestionusuarios/modificar-usuario/:idUsuario/:encryp',
    component: EditUserForm,
    permission: 'modificar-usuario',
    isPrivate: true,
  },
  {
    title: 'Registro',
    path: 'home/registracion',
    component: RegisterProvider,
    isPrivate: false,
  },
  {
    title: 'Iniciar Sesión',
    path: 'login-mobile',
    component: LoginFormMobilePage,
    isPrivate: false,
  },
  {
    title: 'Olvidé mi Contraseña',
    path: 'forgot-password',
    component: ForgotPasswordContainer,
    isPrivate: false,
  },
  {
    title: 'Nueva Contraseña',
    path: 'forgot-password/new-password',
    component: NewPassword,
    isPrivate: false,
  },
  {
    title: 'Términos y Condiciones',
    path: 'terminos-y-condiciones',
    component: TermsAndConditionsPage,
    permission: 'terminos',
    isPrivate: true,
  },
];

export default userRoutes;
